import { useState, useEffect } from 'react';

const useWeather = () => {
    const [temperature, setTemperature] = useState(null);

    useEffect(() => {
        const fetchWeather = async () => {
            try {
                const response = await fetch('https://api.openweathermap.org/data/2.5/weather?lat=36.5817&lon=36.165&units=metric&appid=ca7e0316600e16cb522463ae834840de');
                const data = await response.json();
                if (data && data.main && data.main.temp_max) {
                    setTemperature(Math.round(data.main.temp_max));
                }
            } catch (error) {
                console.error('Weather data fetch error:', error);
            }
        };

        fetchWeather();
        // Refresh weather data every 30 minutes
        const interval = setInterval(fetchWeather, 30 * 60 * 1000);

        return () => clearInterval(interval);
    }, []);

    return temperature;
};

export default useWeather;
